//13
import { controls } from "../../controls";

const rp1014 = {
  label: "MOU LIABILITY REGISTER",
  pageLabel: "MOU LIABILITY REGISTER",
  starting: true,
  url: "rp1014",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    
       ...controls.displayText({tab: "filter",label: "April Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"april_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "May Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"May_date",width:"col-sm-2"}),    
    
    ...controls.displayText({tab: "filter",label: "June Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"june_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "July Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"july_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "August Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"august_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "September Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"September_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "October Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"october_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "November Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"november_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "December Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"december_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "January Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"january_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "February Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"february_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "March Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"march_date",width:"col-sm-2"}),
      ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "MOU REGISTER Liability ",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
     {
        Header: "Date",
        accessor: "date",
        type:"date",
        rwidth:"*"

      },
      {
        Header: "Share Capital",
        columns: [
          {
            Header: "Institution",
            accessor: "institution",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Individual",
            accessor: "individual",
            type:"currency",
            rwidth:"*"
          },
          {
            accessor: "Total",
            Header: "total",
            type:"currency",
            rwidth:"*"
          }
        ]
      },

      {
        Header: "Reserves",
        columns: [
          {
            Header: "Statutory Reserves",
            accessor: "statutory_reserves",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Other Reserves",
            accessor: "other_reserves",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Other Provisions",
            accessor: "other_provisions",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Total",
            accessor: "total",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Provision for Standard Assets",
            accessor: "provision_for_standard_assets",
            type:"currency",
            rwidth:"*"
          },
          {
            accessor: "provision_for_npas ",
            Header: "Provision For NPAs",
            type:"currency",
            rwidth:"*"
          },
          {
            accessor: "provision_for_overdue_intrest ",
            Header: "Provision For Overdue Interest",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Total",
            accessor: "total",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Total",
            accessor: "total",
            type:"currency",
            rwidth:"*"
          }
           
        ]
      },


       

      {
        Header: "Saving Deposits",
        columns:[
            {
                Header: "Instution",
                accessor: "intutuion",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "Individual",
                accessor: "individual",
                type:"currency",
                rwidth:"*"
              },
              {
                accessor: "Total",
                Header: "total",
                type:"currency",
                rwidth:"*"
              }

        ]
    },

    {
        Header: "Current Deposits",
        columns:[
            {
                Header: "Institution",
                accessor: "institution",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "Individual",
                accessor: "individual",
                type:"currency",
                rwidth:"*"
              },
              {
                accessor: "Total",
                Header: "total",
                type:"currency",
                rwidth:"*"
              }

        ]
    },


    {
        Header: "Fixed Deposits",
        columns:[
            {
                Header: "Instution",
                accessor: "intutuion",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "Individual",
                accessor: "individual",
                type:"currency",
                rwidth:"*"
              },
              {
                accessor: "Total",
                Header: "total",
                type:"currency",
                rwidth:"*"
              }

        ]
    },


    {
        Header: "Total",
        columns:[
            {
                Header: "Institution",
                accessor: "institution",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "Individual",
                accessor: "individual",
                type:"currency",
                rwidth:"*"
              }              

        ]
    },


    {
        Header: "Total Deposits ",
        accessor: "total_deposits",
       // width: 10,
        type:"currency",
        rwidth:"*"

    },

      {
        Header: "Borrowing",
        columns:[
            {
                Header: "S.T.SAO",
                accessor: "s.t.sao",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "S.T.Other/MSC OD",
                accessor: "s.t.other/msc_od",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "M.T.Agri",
                accessor: "m.t.agri",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "M.T.Non-Agri",
                accessor: "m.t.non-agri",
                type:"currency",
                rwidth:"*"
              },  
              {
                Header: "M.T.CON",
                accessor: "m.t.con",
                type:"currency",
                rwidth:"*"
              },            
              {
                Header: "L.T.Agri",
                accessor: "l.t.agri",
                type:"currency",
                rwidth:"*"
              },  
              {
                Header: "L.T.Non-Agri",
                accessor: "l.t.non-agri",
                type:"currency",
                rwidth:"*"
              },  
              {
                Header: "Total",
                accessor: "total",
                type:"currency",
                rwidth:"*"
              }
        ]
    },


      {
        Header: "Other Liabilities",
        columns:[
            {
                Header: "INT.PAYABLE",
                accessor: "int.payable",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "BR.ADJUSTMENT",
                accessor: "br.adjustment",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "STAFF P/F GRATUTY",
                accessor: "m.t.agri",
                type:"currency",
                rwidth:"*"
              },
              {
                Header: "SHARE SUSPENSE",
                accessor: "share_suspense",
                type:"currency",
                rwidth:"*"
              },  
              {
                Header: "SUNDRY CREDITORS",
                accessor: "sundry_creditors",
                type:"currency",
                rwidth:"*"
              },            
              {
                Header: "OTHER IF ANY",
                accessor: "other_if_any",
                type:"currency",
                rwidth:"*"
              },  
              {
                Header: "TOTAL OF OTHER LIABILITES",
                accessor: "total_of_other_liabilities",
                type:"currency",
                rwidth:"*"
              }
        ]
    },
     

    {
        Header: "Total Deposits ",
        accessor: "total_deposits",
      //  width: 10,
        type:"currency",
        rwidth:"*"

    },

    {
        Header: "Balance In Profit And Loss ",
        accessor: "balance_in_profit_and_loss",
     //   width: 10,
        type:"currency",
        rwidth:"*"

    },

    {
        Header: "Excess Of Income Over Expendture",
        accessor: "excess_of_income_over_expendture",
      //  width: 10,
      type:"currency",
        rwidth:"*"

    },

    {
        Header: "Grand Total Of Working Fund",
        accessor: "grand_total_of_working_fund",
       // width: 10,
       type:"currency",
        rwidth:"*"

    },

    {
        Header: "Contra",
        accessor: "contra",
       //width: 10,
       type:"currency",
        rwidth:"*"

    },

    {
        Header: "Total As Per BalanceSheet",
        accessor: "total_as_per_balancesheet",
       // width: 10,
       type:"currency",
        rwidth:"*"

    }
               
    ]
  }
};

export default rp1014;